// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"531c3a41","453":"42b97e38","564":"32875b80","615":"13d34461"}[chunkId] + ".chunk.js";
};